import { isEmpty } from "lodash";

import {
  EligibilityCheck,
  GetPatient,
  GetPatientInformationPayload,
  LogContractIdPbpPayload,
  SaveInformation,
} from "../models/Patient";
import API from "./api";

export const CheckEligibility = (baseUrl: string, payload: EligibilityCheck) =>
  API.postApi(`${baseUrl}api/Eligibility/Check`, payload);

export const GetPatientFromMBI = (baseUrl: string, payload: GetPatient) => {
  const { lastName, dob, subscriberId, mbi } = payload;
  const mbiValue = isEmpty(mbi) ? "" : `?mbi=${mbi}`;
  const url = `${baseUrl}api/ReferralService/${lastName}/${dob}/${subscriberId}${mbiValue}`;
  return API.get(url);
};

export const Information = (baseUrl: string, payload: SaveInformation) =>
  API.postApi(`${baseUrl}api/ReferralService/Information`, payload);

export const CreatePatient = (baseUrl: string, payload: any) =>
  API.postApi(`${baseUrl}api/Patients`, payload);

export const GetPatientInformationById = (
  baseUrl: string,
  payload: GetPatientInformationPayload
) =>
  API.get(
    `${baseUrl}api/ReferralService/patientdetail/${payload.id}/${payload.type}`
  );

export const GetIcdCode = (baseUrl: string, input: string) =>
  API.get(`${baseUrl}api/ReferralService/IcdDiagnosisType?searchText=${input}`);

export const GetHealthPlanDetailsByBenefitPlanUid = (baseUrl: string, benefitPlanUid: string) =>
  API.get(`${baseUrl}api/ReferralService/BenefitPlanUid?benefitPlanUid=${benefitPlanUid}`);

export const LogContractIdPBPDetails = (baseUrl: string, payload: LogContractIdPbpPayload) =>
  API.postApi(`${baseUrl}api/ReferralService/LogContractIdPBPDetails`, payload);